export const AB_TESTS_NAMES = {
    ALERTS: 'alerts',
    ASSET_SLIDE_WITH_EXPANDED_GRAPH: 'asset_slide_with_expanded_graph',
    BEGINNERS_GUIDE: 'beginners_guide',
    CASHIER_AMOUNT_FIELD_PLUS_MINUS_REDESIGN: 'cashier_amount_field_plus_minus_redesign',
    DEMO_LIMITS: 'demo_limits',
    DEPOSIT_AMOUNT_REDESIGN: 'deposit_amount_redesign',
    DEPOSIT_ONBOARDING: 'deposit_onboarding',
    FIRST_START_INTRO: 'first_start_intro',
    HOME_SCREEN_2: 'home_screen_2',
    HOME_SCREEN_ALWAYS_RESPAWN: 'home_screen_always_respawn',
    LANDING_PAGE: 'landing_page',
    MIN_DEPOSIT: 'min_deposit',
    MOBILE_ACCOUNT_BOX_CONTENT_REDESIGN: 'mobile_account_box_content_redesign',
    MOBILE_DEPOSIT_BONUS_PRIMARY_BUTTON: 'mobile_deposit_bonus_primary_button',
    MOBILE_ONBOARDING: 'mobile_onboarding',
    ONBOARDING_CHOOSE_ACCOUNT_TYPE: 'onboarding_choose_account_type',
    OPEN_ORDER_V2: 'open_order_v2',
    REGISTER_FIELD_PHONE: 'register_field_phone',
    REGISTRATION_ADDITIONAL_CHECKBOX: 'registration_additional_checkbox',
    SPREADS_FIXED_DEMO: 'spreads_fixed_demo',
    TRUST_USER_WITHOUT_VERIFY: 'trust_user_without_verify',
    TUTORIALS: 'tutorials',
} as const;

export const AB_TESTS_LANDING_PAGE_OPTIONS = {
    INITIAL: 0,
    REDESIGN: 1,
} as const;

export const AB_TEST_MOBILE_DEPOSIT_BONUS_PRIMARY_BUTTON_OPTIONS = {
    GET_APP: 0,
    CASHIER: 1,
} as const;

export const AB_TEST_REGISTER_FIELD_PHONE_OPTIONS = {
    SHOW: 0,
    HIDE: 1,
} as const;

export const AB_TEST_TRUST_USER_WITHOUT_VERIFY_OPTIONS = {
    DEFAULT: 0,
    SHOW_VERIFY: 1,
    NO_VERIFY: 2,
    AUTO_APPROVE: 3,
} as const;

export const AB_TEST_DEPOSIT_ONBOARDING_OPTIONS = {
    DISABLED: 0,
    ENABLED: 1,
} as const;

export const AB_TEST_OPEN_ORDER_V2_OPTIONS = {
    DISABLED: 0,
    ENABLED: 1,
} as const;

export const AB_TEST_MOBILE_ONBOARDING_OPTIONS = {
    DISABLED: 0,
    ENABLED: 1,
} as const;

export const AB_TEST_ONBOARDING_CHOOSE_ACCOUNT_TYPE_OPTIONS = {
    DISABLED: 0,
    LIVE_CARD_SECOND__LIVE_BUTTON_HOME: 1,
    LIVE_CARD_FIRST__LIVE_BUTTON_HOME: 2,
    LIVE_CARD_FIRST__LIVE_BUTTON_DEPOSIT: 3,
} as const;

export const AB_TEST_HOME_SCREEN_2_OPTIONS = {
    DISABLED: 0,
    ENABLED: 1,
} as const;

export const AB_TEST_TUTORIALS_OPTIONS = {
    DISABLED: 0,
    ENABLED: 1,
} as const;

export const AB_TEST_ALERTS_OPTIONS = {
    DISABLED: 0,
    ENABLED: 1,
} as const;

export const AB_TEST_ASSET_SLIDE_WITH_EXPANDED_GRAPH_OPTIONS = {
    DISABLED: 0,
    INITIAL_GRAPH_EXPANDED: 1,
    INITIAL_GRAPH_SIMPLE: 2,
} as const;

export const AB_TEST_REGISTRATION_ADDITIONAL_CHECKBOX_OPTIONS = {
    DISABLED: 0,
    ENABLED: 1,
}

export const AB_TEST_FIRST_START_INTRO_OPTIONS = {
    DISABLED: 0,
    ENABLED: 1,
} as const;

export const AB_TEST_BEGINNERS_GUIDE_OPTIONS = {
    DISABLED: 0,
    ENABLED: 1,
} as const;

export const AB_TEST_MOBILE_ACCOUNT_BOX_CONTENT_REDESIGN_OPTIONS = {
    DISABLED: 0,
    ENABLED: 1,
} as const;
